
import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import nameTemplate from 'report/properties/main/chart-axes.ejs';


class MainChartAxesView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #verticalAxis,#horizontalAxis' : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    updateChartAxes(){
        $(`select[name="verticalAxis"] option[value='${this.model.get('verticalAxis')}']`).prop('selected', true);
        $(`select[name="horizontalAxis"] option[value='${this.model.get('horizontalAxis')}']`).prop('selected', true);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
            this.updateChartAxes();
        }
        this.delegateEvents();
        return this;
    }

}

export default MainChartAxesView;
